"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderTime = void 0;

// @TODO CREATE A PACKAGE IN KNXLAB FOR THAT
var paddTime = function paddTime(time) {
  return time < 10 ? "0" + time : time + "";
};

var renderTime = function renderTime(value) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'short';
  var minutes = Math.floor(value / 60);
  var seconds = Math.round((value / 60 - minutes) * 60);

  switch (format) {
    case 'short':
      return (minutes ? "".concat(paddTime(minutes), ":") : '') + "".concat(paddTime(seconds));

    case 'veryshort':
      return (minutes ? "".concat(minutes, ":") : '') + "".concat(seconds);

    default:
      return (minutes ? "".concat(paddTime(minutes), "min ") : "") + "".concat(paddTime(seconds), "s");
  }
};

exports.renderTime = renderTime;